export const addresses = [
    {
        id: 1,
        title: 'Parque Empresarial da Calheta',
        name: 'Estreito da Calheta',
        postal: '370-250 Estreito Da Calheta',
        cords: `32°44'55.9"N 17°11'30.4"W`,
        link: "https://www.google.pt/maps/place/32%C2%B044'55.9%22N+17%C2%B011'30.4%22W/@32.7488611,-17.1943527,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.7488611!4d-17.1917778?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
    {
        id: 2,
        title: 'Parque Empresarial da Camacha',
        name: 'Parque Empresarial da Camacha',
        postal: '9135-401 Camacha',
        cords: `32°40'04.8"N 16°51'20.9"W`,
        link: "https://www.google.pt/maps/place/32%C2%B040'04.8%22N+16%C2%B051'20.9%22W/@32.668,-16.8583805,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.668!4d-16.8558056?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
    {
        id: 3,
        title: 'Parque Empresarial de Câmara de Lobos',
        name: 'Parque Empresarial de Câmara de Lobos Estrada da Ribeira Garcia ',
        postal: '9300-324 Câmara de Lobos',
        cords: `32°40'03.9"N 16°59'50.6"W`,
        link: "https://www.google.pt/maps/place/32%C2%B040'03.9%22N+16%C2%B059'50.6%22W/@32.66775,-16.9999638,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.66775!4d-16.9973889?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
    {
        id: 4,
        title: 'Parque Empresarial da Cancela',
        name: 'Parque Empresarial da Cancela ',
        postal: '9125-042 Caniço',
        cords: `32°38'53.7"N 16°51'37.8"W`,
        link: "https://www.google.com/maps/place/32%C2%B038'53.7%22N+16%C2%B051'37.8%22W/@32.64825,-16.8630749,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.64825!4d-16.8605?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D",
    },
    {
        id: 5,
        title: 'Parque Empresarial de Machico',
        name: 'Parque Empresarial de Machico ',
        postal: '9200-405 Machico',
        cords: `32°43'50.3"N 16°48'14.4"W`,
        link: "https://www.google.pt/maps/place/32%C2%B043'50.3%22N+16%C2%B048'14.4%22W/@32.7434539,-16.8217884,15z/data=!4m4!3m3!8m2!3d32.7306389!4d-16.804?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
    },
    {
        id: 6,
        title: 'Parque Empresarial do Porto Moniz',
        name: 'Parque Empresarial do Porto Moniz ',
        postal: '9270 Porto Moniz',
        cords: `32°50'58.6"N 17°11'44.0"W`,
        link: "https://www.google.com/maps/place/32%C2%B050'58.6%22N+17%C2%B011'44.0%22W/@32.8496111,-17.1981305,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.8496111!4d-17.1955556?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D",
    },
    {
        id: 7,
        title: 'Parque Empresarial do Porto Santo',
        name: 'Parque Empresarial do Porto Santo Tanque ',
        postal: '9400-100 Porto Santo',
        cords: `33°04'20.7"N 16°20'36.0"W`,
        link: "https://www.google.com/maps/place/33%C2%B004'20.7%22N+16%C2%B020'36.0%22W/@33.0724167,-16.3459082,17z/data=!3m1!4b1!4m4!3m3!8m2!3d33.0724167!4d-16.3433333?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D",
    },
    {
        id: 8,
        title: 'Parque Empresarial da Ribeira Brava',
        name: 'Sitio Da Boa Morte ',
        postal: '9350-104 Ribeira Brava',
        cords: `32°40'59.4"N 17°02'24.2"W`,
        link: "https://www.google.com/maps/place/32%C2%B040'59.4%22N+17%C2%B002'24.2%22W/@32.6831667,-17.0426305,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.6831667!4d-17.0400556?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D",
    },
    {
        id: 9,
        title: 'Parque Empresarial de Santana',
        name: 'Estrada do Pico ',
        postal: '9230-096 Redondo Santana',
        cords: `32°47'10.3"N 16°52'49.0"W`,
        link: "https://www.google.com/maps/place/32%C2%B047'10.3%22N+16%C2%B052'49.0%22W/@32.7861944,-16.8828527,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.7861944!4d-16.8802778?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D",
    },
    {
        id: 10,
        title: 'Parque Empresarial de São Vicente',
        name: 'Parque Empresarial de São Vicente ',
        postal: '9240 São Vicente',
        cords: `32°46'48.5"N 17°02'48.1"W`,
        link: "https://www.google.com/maps/place/32%C2%B046'48.5%22N+17%C2%B002'48.1%22W/@32.7801389,-17.0492693,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.7801389!4d-17.0466944?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D",
    },
    {
        id: 11,
        title: 'Parque Empresarial da Zona Oeste',
        name: 'Parque Empresarial Zona Oeste ',
        postal: '9300-020 Câmara de Lobos',
        cords: `32°38'43.5"N 16°58'11.8"W`,
        link: "https://www.google.com/maps/place/32%C2%B038'43.5%22N+16%C2%B058'11.8%22W/@32.6454167,-16.9725193,17z/data=!3m1!4b1!4m4!3m3!8m2!3d32.6454167!4d-16.9699444?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D",
    },
];